"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Modifier {
}
exports.default = Modifier;
//# sourceMappingURL=Modifier.js.map